import { Box, Button, Tab, Tabs } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import useResources from "../../../../hooks/useResources";
import useResourceTypes from "../../../../hooks/useResourceTypes";
import Searchbar from "../../../components/searchbar/Searchbar";
import TabPanel from "../../../components/TabPanel/TabPanel";
import AddResource from "./addResource/AddResource";
import AddResourceType from "./addResourceType/AddResourceType";
import classes from "./Resources.module.css";
import ResourcesTable from "./resourcesTable/ResourcesTable";
import ResourceTypeTable from "./resourceTypeTable/ResourceTypeTable";

const Resources = () => {
   const [value, setValue] = React.useState(0);

   const handleChange = (_, newValue) => {
      setValue(newValue);
   };

   const { openResourceTypeForm, getResourceTypes, searchResourceType } =
      useResourceTypes();
   const { openResourceForm, searchResources } = useResources();

   useEffect(() => {
      getResourceTypes({ pageSize: 10, pageNo: 0 });
   }, []);

   const {
      resources: { openForm },
   } = useSelector((state) => state);

   return (
      <Box sx={{ width: "100%" }}>
         <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={value} onChange={handleChange}>
               <Tab label="Resources" route="/resource" />
               <Tab label="Resource Type" route="/resourcetype" />
            </Tabs>
         </Box>
         <TabPanel value={value} index={0}>
            <Box className={classes.buttons}>
               <Button
                  className={classes.button}
                  onClick={openResourceForm}
                  variant="outlined"
               >
                  Add Resource +
               </Button>
               <Searchbar
                  label="Search resources"
                  onSearchFunction={searchResources}
               />
            </Box>
            <ResourcesTable />

            {openForm && <AddResource />}
         </TabPanel>
         <TabPanel value={value} index={1}>
            <Box className={classes.buttons}>
               <Button
                  className={classes.button}
                  onClick={openResourceTypeForm}
                  variant="outlined"
               >
                  Add Resource type +
               </Button>
               <Searchbar
                  label="Search resources types"
                  onSearchFunction={searchResourceType}
               />
            </Box>
            <ResourceTypeTable />
            <AddResourceType />
         </TabPanel>
      </Box>
   );
};

export default Resources;
